module.exports = __webpack_public_path__ + "media/application/images/icons/mail_red_dark-bb7bf7469cac5d81745e902834ed971c.svg";